import React from 'react';
import { Check } from 'lucide-react';

/**
 * CheckBox Component
 * Un componente checkbox personalizzato con supporto per temi light/dark
 * 
 * @component
 * @example
 * <CheckBox
 *   checked={isChecked}
 *   onChange={(checked) => setIsChecked(checked)}
 *   label="Accetta termini e condizioni"
 * />
 * 
 * @param {Object} props - Proprietà del componente
 * @param {boolean} [props.checked=false] - Stato del checkbox
 * @param {Function} props.onChange - Callback chiamata quando cambia lo stato
 * @param {string} [props.label] - Label del checkbox
 * @param {boolean} [props.disabled=false] - Disabilita il checkbox
 * @param {string} [props.className=''] - Classi CSS aggiuntive
 * @returns {JSX.Element}
 */
const CheckBox = ({
  checked = false,
  onChange,
  label,
  disabled = false,
  className = '',
}) => {
  const handleChange = (e) => {
    if (!disabled && onChange) {
      onChange(e.target.checked);
    }
  };

  return (
    <label className={`
      inline-flex items-center gap-2 cursor-pointer
      ${disabled ? 'cursor-not-allowed opacity-50' : ''}
      ${className}
    `}>
      <div className={`
        relative w-5 h-5 flex items-center justify-center
        rounded border transition-all duration-200
        ${checked 
          ? 'bg-light-primary dark:bg-dark-primary border-light-primary dark:border-dark-primary' 
          : 'bg-light-surface dark:bg-dark-surface border-light-outline dark:border-dark-outline'
        }
        ${!disabled && !checked && 'hover:border-light-primary dark:hover:border-dark-primary'}
        ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
      `}>
        <input
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          className="absolute opacity-0 w-full h-full cursor-pointer"
        />
        {checked && (
          <Check 
            size={14} 
            className={`
              text-light-on-primary dark:text-dark-on-primary
              ${disabled ? 'opacity-50' : ''}
            `}
          />
        )}
      </div>
      {label && (
        <span className="text-sm text-light-on-surface dark:text-dark-on-surface">
          {label}
        </span>
      )}
    </label>
  );
};

export default CheckBox;
